import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "how-to-play" }
const _hoisted_2 = { class: "section-title large" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "sections" }
const _hoisted_5 = { class: "instruction-section" }
const _hoisted_6 = { class: "section-content image-first" }
const _hoisted_7 = { class: "image-content" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-content" }
const _hoisted_10 = { class: "instruction-section" }
const _hoisted_11 = { class: "section-content image-last" }
const _hoisted_12 = { class: "text-content" }
const _hoisted_13 = { class: "image-content" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "instruction-section" }
const _hoisted_16 = { class: "section-content image-first" }
const _hoisted_17 = { class: "image-content" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "text-content" }
const _hoisted_20 = { class: "instruction-section" }
const _hoisted_21 = { class: "section-content image-last" }
const _hoisted_22 = { class: "text-content" }
const _hoisted_23 = { class: "image-content" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "instruction-section" }
const _hoisted_26 = { class: "section-content image-first" }
const _hoisted_27 = { class: "image-content" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "text-content" }
const _hoisted_30 = { class: "instruction-section" }
const _hoisted_31 = { class: "section-content image-last" }
const _hoisted_32 = { class: "text-content" }
const _hoisted_33 = { class: "image-content" }
const _hoisted_34 = ["src"]

import { computed } from 'vue'

import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'HowToPlayView'
},
  __name: 'HowToPlayView',
  setup(__props) {



const { getAssetPath } = useTheme()

const howToPlayStep1 = computed(() => getAssetPath('howToPlay', 'step1') || '/img/images/how-to-play/1-select-game.png')
const howToPlayStep2 = computed(() => getAssetPath('howToPlay', 'step2') || '/img/images/how-to-play/2-select-draws.png')
const howToPlayStep3 = computed(() => getAssetPath('howToPlay', 'step3') || '/img/images/how-to-play/3-select-market.png')
const howToPlayStep4 = computed(() => getAssetPath('howToPlay', 'step4') || '/img/images/how-to-play/4-confirm-your-entries.png')
const howToPlayStep5 = computed(() => getAssetPath('howToPlay', 'step5') || '/img/images/how-to-play/5-your-betslip.png')
const howToPlayStep6 = computed(() => getAssetPath('howToPlay', 'step6') || '/img/images/how-to-play/6-wager-details.png')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('howToPlay.title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('howToPlay.subtitle')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: howToPlayStep1.value,
              alt: "Select Your Game"
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step1Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step1Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step1Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step1Text3')), 1)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step2Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step2Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step2Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step2Text3')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: howToPlayStep2.value,
              alt: "Select Your Draws"
            }, null, 8, _hoisted_14)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              src: howToPlayStep3.value,
              alt: "Select Your Market"
            }, null, 8, _hoisted_18)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step3Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step3Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step3Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step3Text3')), 1)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step4Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step4Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step4Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step4Text3')), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              src: howToPlayStep4.value,
              alt: "Confirm Your Entries"
            }, null, 8, _hoisted_24)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("img", {
              src: howToPlayStep5.value,
              alt: "Your Betslip"
            }, null, 8, _hoisted_28)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step5Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step5Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step5Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step5Text3')), 1)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('howToPlay.step6Title')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step6Text1')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step6Text2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('howToPlay.step6Text3')), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("img", {
              src: howToPlayStep6.value,
              alt: "Wager Details"
            }, null, 8, _hoisted_34)
          ])
        ])
      ])
    ])
  ]))
}
}

})